module.exports = __webpack_public_path__ + "img/s7Model3M.68d912d0.webp";